module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/banner-mobile-7257ba2d5ae18e2a9ed67579456a8ab3.svg";